function isHeroFullBGRepeatableBackgroundImageKey(componentName, key) {
    return (
        componentName === 'HeroFullBG' &&
        /^Images\[\d+\]\.ImageUrl$/i.test(String(key || ''))
    );
}

module.exports = { isHeroFullBGRepeatableBackgroundImageKey };
